var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('a',{ref:"widgetTarget",staticClass:"twitter-widget-target"})])
}
var staticRenderFns = []

export { render, staticRenderFns }